export default "__VITE_ASSET__abe8e127__"